import { Reducer } from 'redux';
import { CoreActionTypes, OfferState, Status, VisaStatus } from './types';
import { Q, StudentActionTypes } from '../types';
import { AuthActionTypes } from '../../auth/types';
import { IRecordedInterviewEntry, PartnerVisaStatus } from 'types';

const initialState: OfferState = {
  offerId: '',
  intakeId: '',
  courses: [],
  // courseFeePaidToDate: 0,
  // accomFeePaidToDate: 0,
  status: Status.PRE_DEPOSIT,
  visaStatus: VisaStatus.NONE,
  assignedAgents: [],
  calendlyInterviews: [],
  recordedInterviews: undefined,
  recordedInterviewSystemStatus: undefined,
  isExceedingInterview: false
};

const reducer: Reducer<OfferState> = (state = initialState, action) => {
  switch (action.type) {
    case AuthActionTypes.COGNITO_LOGIN_SUCCESS: {
      const { uni } = action.payload.sessionContext;
      return {
        ...state,
        university: uni
      };
    }
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return { ...initialState, ...action.payload.student.offer };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.SAVE_DOCUMENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS:
      if (action.payload.offer) {
        return { ...initialState, ...action.payload.offer };
      }
      return state;

    case CoreActionTypes.UPDATE_VISA_STATUS: {
      return {
        ...state,
        // SHLD-970
        // status: getUpdatedStudentStatus(action.payload, state.status),
        visaStatus: action.payload
      };
    }
    case CoreActionTypes.UPDATE_OFFER_FIELD: {
      return {
        ...state,
        [action.payload.fieldName]: action.payload.value
      };
    }
    case StudentActionTypes.SAVE_RECORDED_INTERVIEW_ATTEMPT_SUCCESS: {
      const payload: [string, IRecordedInterviewEntry][] = Object.entries(action.payload);
      const key = payload[0][0];
      const value = payload[0][1];
      return {
        ...state,
        recordedInterviews: {
          ...state.recordedInterviews,
          [key]: {
            ...state.recordedInterviews?.[key],
            recorded: value.recorded,
            questions: value.questions,
            attempts: value.attempts,
            isWidgetOpened: value.recorded ? false : true
          }
        }
      };
    }
    case StudentActionTypes.RECORDED_INTERVIEW_IS_WIDGET_OPENED: {
      const key = action.payload.key;
      const isWidgetOpened = action.payload.isWidgetOpened;
      return {
        ...state,
        recordedInterviews: {
          ...state.recordedInterviews,
          [key]: {
            ...state.recordedInterviews?.[key],
            isWidgetOpened: isWidgetOpened
          }
        }
      };
    }
    case Q.SPOUSE_TRAVELLING: {
      if (action.payload.value === false) {
        return {
          ...state,
          [Q.PARTNER_VISA_STATUS]: '' as PartnerVisaStatus,
          [action.payload.fieldName]: action.payload.value
        };
      }
      return {
        ...state,
        [action.payload.fieldName]: action.payload.value
      };
    }
    case Q.CHILDREN_TRAVELLING: {
      if (action.payload.value === false) {
        return {
          ...state,
          [Q.CHILDREN_TRAVELLING_NUMBER]: 0,
          [action.payload.fieldName]: action.payload.value
        };
      }
      return {
        ...state,
        [action.payload.fieldName]: action.payload.value
      };
    }
    case StudentActionTypes.SAVE_VIEWED_BYPASS_WELCOME_MESSAGE_SUCCESS: {
      return {
        ...state,
        hasViewedBypassWelcomeMessage: true
      };
    }

    case StudentActionTypes.UPDATE_CALENDLY_INTERVIEW_WS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case StudentActionTypes.REQUEST_RECORDED_INTERVIEW_SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case StudentActionTypes.EXCEED_RECORDED_INTERVIEW: {
      return {
        ...state,
        isExceedingInterview: true
      };
    }
    case StudentActionTypes.EXCEED_RECORDED_INTERVIEW_SUCCESS: {
      return {
        ...state,
        recordedInterviews: {
          ...action.payload
        }
      };
    }
    case StudentActionTypes.EXCEED_RECORDED_INTERVIEW_FAILURE: {
      return {
        ...state,
        isExceedingInterview: false
      };
    }
    case StudentActionTypes.GET_STUDENT_RECORDED_INTERVIEWS_SUCCESS: {
      if (action.payload.recordedInterviews) {
        return {
          ...state,
          recordedInterviews: action.payload.recordedInterviews
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export { reducer as offerReducer };
